import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import consola from 'consola';
import * as types from './types';
import { createCart, fetchCart as _fetchCart, addCart as _addCart, updateCart as _updateCart } from // addCartCustomizable,
'~/services/cart';

var formatMinicart = function formatMinicart(items) {
  return items.reduce(function (acc, item) {
    return _objectSpread({}, acc, _defineProperty({}, item.reference, {
      id: item.id,
      quantity: item.quantity
    }));
  }, {});
};

var getGraphQLErrorsCode = function getGraphQLErrorsCode(err) {
  if (err.graphQLErrors && err.graphQLErrors.length) {
    return err.graphQLErrors[0].extensions.code || '';
  }

  return '';
};

export default {
  fetchCart: function () {
    var _fetchCart2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var commit, token, _ref2, minicart, newCartItems, code;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              token = window.localStorage.MDM_CART_TOKEN;

              if (token) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              _context.prev = 4;
              _context.next = 7;
              return _fetchCart(this, token);

            case 7:
              _ref2 = _context.sent;
              minicart = _ref2.minicart;
              newCartItems = formatMinicart(minicart.items);
              commit(types.SET_CART_QTY, minicart.quantity);
              commit(types.SET_CART, newCartItems);
              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);
              code = getGraphQLErrorsCode(_context.t0);

              if (code === 'MERCURE_ERROR_CART_NOTFOUND') {
                localStorage.removeItem('MDM_CART_TOKEN');
              } else {
                consola.error(_context.t0);

                if (this.$sentry) {
                  this.$sentry.captureException(_context.t0);
                }
              }

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[4, 14]]);
    }));

    function fetchCart(_x) {
      return _fetchCart2.apply(this, arguments);
    }

    return fetchCart;
  }(),
  addCart: function () {
    var _addCart2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(_ref3, payload) {
      var commit, token, _ref4, createNewCart, _ref5, addProductsToCart;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref3.commit;
              _context2.prev = 1;
              token = window.localStorage.MDM_CART_TOKEN;

              if (token) {
                _context2.next = 12;
                break;
              }

              _context2.next = 6;
              return createCart(this);

            case 6:
              _ref4 = _context2.sent;
              createNewCart = _ref4.createNewCart;

              if (createNewCart) {
                _context2.next = 10;
                break;
              }

              throw new Error('MDM_CART_CANNOT_CREATE_TOKEN');

            case 10:
              token = createNewCart;
              window.localStorage.MDM_CART_TOKEN = token;

            case 12:
              _context2.next = 14;
              return _addCart(this, _objectSpread({
                token: token
              }, payload));

            case 14:
              _ref5 = _context2.sent;
              addProductsToCart = _ref5.addProductsToCart;
              commit(types.SET_CART, formatMinicart(addProductsToCart.items));
              commit(types.SET_CART_QTY, addProductsToCart.quantity);
              commit(types.SET_CART_SUCCESS, true);
              _context2.next = 26;
              break;

            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2["catch"](1);
              commit(types.SET_CART_SUCCESS, false);
              consola.error(_context2.t0);

              if (this.$sentry) {
                this.$sentry.captureException(_context2.t0);
              }

            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[1, 21]]);
    }));

    function addCart(_x2, _x3) {
      return _addCart2.apply(this, arguments);
    }

    return addCart;
  }(),
  // async addCartCustomizable({ commit }, payload) {
  //   // TODO
  //   const data = await addCartCustomizable(this, payload);
  //   if (data.success) {
  //     commit(types.PUSH_CART, { quantity: 1 });
  //     commit(types.SET_CART_SUCCESS, true);
  //   } else {
  //     commit(types.SET_CART_SUCCESS, false);
  //   }
  // },
  updateCart: function () {
    var _updateCart2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(_ref6, payload) {
      var commit, token, id, _ref7, updateCartItems;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref6.commit;
              _context3.prev = 1;
              token = window.localStorage.MDM_CART_TOKEN;

              if (token) {
                _context3.next = 5;
                break;
              }

              throw new Error('MDM_CART_TOKEN_UNDEFINED');

            case 5:
              id = this.state.cart.items[payload.reference].id;
              _context3.next = 8;
              return _updateCart(this, _objectSpread({
                token: token,
                id: id
              }, payload));

            case 8:
              _ref7 = _context3.sent;
              updateCartItems = _ref7.updateCartItems;
              commit(types.SET_CART, formatMinicart(updateCartItems.items));
              commit(types.SET_CART_QTY, updateCartItems.quantity);
              commit(types.SET_CART_SUCCESS, true);
              _context3.next = 20;
              break;

            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3["catch"](1);
              commit(types.SET_CART_SUCCESS, false);
              consola.error(_context3.t0);

              if (this.$sentry) {
                this.$sentry.captureException(_context3.t0);
              }

            case 20:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[1, 15]]);
    }));

    function updateCart(_x4, _x5) {
      return _updateCart2.apply(this, arguments);
    }

    return updateCart;
  }()
};